export default {
  title: 'Treasury',

  banks: {
    title: 'Banks',

    insert: {
      title: 'Create Bank',

      notifications: {
        insert: {
          success: 'New bank information successfully registered',
          error: 'Registering new bank information failed'
        }
      }
    },

    list: {
      title: 'Banks'
    },

    trash: {
      title: 'Banks trash',

      confirmations: {
        delete: {
          title: 'Bank Deletion Confirmation',
          body: 'Are you sure you want to delete {bank} permanently?'
        }
      },

      notifications: {
        restore: {
          success: 'Bank information successfully restored',
          error: 'Retrieving bank information failed'
        },

        delete: {
          success: 'Permanent deletion of bank information completed successfully',
          error: 'Permanent deletion of bank information was accompanied by an error'
        }
      }
    },

    edit: {
      title: 'Edit Bank',
      dynamicTitle: 'Edit Bank {bank}',

      confirmations: {
        delete: {
          title: 'Bank Deletion Confirmation',
          body: 'Are you sure you want to temporarily delete {bank}?'
        }
      },

      notifications: {
        edit: {
          success: 'Bank information successfully edited',
          error: 'Editing bank information failed'
        },

        delete: {
          success: 'Deleting bank information successfully',
          error: 'Deleting bank information was accompanied by an error'
        }
      }
    },

    bank: {
      title: 'Bank',
      dynamicTitle: 'Bank {bank}',

      importantData: {
        balance: 'Balance',
        openingBalance: 'Opening balance',
        transactionsCount: 'Number of transactions'
      },

      actions: {
        transactions: 'Bank transactions',
        logs: 'Activity logs'
      }
    },

    transactions: {
      title: 'Bank Turnover',
      dynamicTitle: 'Bank Turnover {bank}',

      table: {
        header: {
          balance: 'Balance',
          price: 'Amount',
          description: 'Documents',
          date: 'Date',
          docNumber: 'Document number'
        }
      }
    },

    logs: {
      title: 'Bank Logs',
    },

    openingBalance: {
      title: '',

      table: {
        header: {
          row: 'Row',
          name: 'Bank name',
          price: 'Amount',
          delete: 'Delete'
        }
      },

      notifications: {
        locked: 'is the opening balance of the lock',
        negativeBalance: 'Bank cant get negative balance',

        isExisted: {
          message: 'This value is in the list',
          dynamicMessage: 'Bank {bank} is on the list'
        },

        insert: {
          success: 'The opening balance of the bank was successfully registered',
          error: 'The registration of the bank opening balance was accompanied by an error'
        },

        edit: {
          success: 'The first period of the bank in question was successfully updated',
          error: 'The update of the desired bank opening balance was accompanied by an error'
        },

        delete: {
          success: 'The deletion of the bank in question was successfully completed',
          error: 'The deletion of the desired bank opening balance was accompanied by an error'
        }
      },

      insert: {
        title: 'The first addition of the bank course'
      },

      edit: {
        title: 'First edition of the bank period {bank}',

        confirmations: {
          delete: {
            title: 'Delete Confirmation',
            body: 'Are you sure you want to delete the first bank term?'
          }
        },

        labels: {
          price: 'Amount',
          delete: 'Delete first course'
        }
      }
    },

    table: {
      header: {
        select: 'Select',
        row: 'Row',
        name: 'Name',
        cardNumber: 'Card number',
        accountNumber: 'Account number',
        balance: 'Balance',
        delete: 'Delete',
        restore: 'Restore'
      }
    },

    labels: {
      name: 'Name',
      accountNumber: 'Account number',
      cardNumber: 'Card number',
      shebaNumber: 'Number of Sheba',
      delete: 'Delete Bank'
    },

    validators: {
      name: 'Bank name is not entered correctly',
      accountNumber: 'Account number is not entered correctly',
      cardNumber: 'Card number is not entered correctly',
      shebaNumber: 'Sheba number is not entered correctly'
    }
  },

  paymentGateways: {
    title: 'Gateways',

    labels: {
      status: 'Status',
      type: 'Type',
      bank: 'Clearing bank',
      title: 'Portal Title',
      endTime: 'Ports working day end time',
      merchantCode: 'Acceptor code',
      terminalCode: 'Terminal code',
      description: 'Description',
      provider: 'Provider',
      delete: 'Delete payment gateway'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        balance: 'Balance',
        bank: 'Clearing bank',
        status: 'Status',
        title: 'Portal Title',
        type: 'Port type',
        row: 'Row'
      }
    },

    types: {
      all: 'All',
      pos: 'POS',
      online: 'Internet'
    },

    status: {
      all: 'All',
      enable: 'enabled',
      disable: 'inactive'
    },

    confirmations: {
      delete: {
        title: 'Confirmation of payment gateway removal',
        body: 'Are you sure you want to delete "{paymentGateway}" permanently?',
        body1: 'Are you sure you want to delete "{paymentGateway}" temporarily?'
      }
    },

    notifications: {
      incorrectData: 'The information was not entered correctly',

      insert: {
        success: 'Payment gateway created successfully',
        error: 'There was an error creating the payment gateway'
      },

      edit: {
        success: 'Payment gateway successfully updated',
        error: 'Payment gateway update encountered error'
      },

      delete: {
        success: 'Payment gateway successfully deleted',
        error: 'Deleting the payment gateway was accompanied by an error'
      },

      restore: {
        success: 'Payment gateway successfully restored',
        error: 'There was an error returning the payment gateway'
      }
    },

    insert: {
      title: 'Create Payment gateway',
      suggestTitle: '{type} Bank {bank}'
    },

    list: {
      title: 'Gateways'
    },

    trash: {
      title: 'Payment gateways Trash'
    },

    edit: {
      title: 'Edit Payment Gateway',
      dynamicTitle: 'Edit {paymentGateway}'
    },

    paymentGateway: {
      title: 'Payment gateway',
      dynamicTitle: '{paymentGateway}',

      importantData: {
        type: 'type',
        bank: 'clearing bank',
        balance: 'Balance'
      },

      actions: {
        transactions: 'financial turnover',
        receive: 'Receipt notification',
        logs: 'Activity logs'
      }
    },

    transactions: {
      title: 'Payment gateway turnover',
      dynamicTitle: 'Turnover {paymentGateway}',

      table: {
        header: {
          balance: 'Balance',
          price: 'Amount',
          description: 'Documents',
          date: 'Date',
          docNumber: 'Document number'
        }
      }
    },

    logs: {
      title: 'Payment gateway logs',
    },

    receive: {
      title: 'Notice of receipt of payment gateway',
      dynamicTitle: 'Receipt Receipt {paymentGateway}',

      labels: {
        receivedBalance: 'Amount received',
        hasWage: 'Commission',
        wage: 'Commission deduction',
        receiveBalanceWithWage: 'Total Price of receipt and commission',
        receivedBalanceTransferId: 'Tracking number',
        totalBalance: 'Total balance',
        receivedYesterdayBalance: 'Total receivable balance'
      },

      notifications: {
        balanceIsNotEnough: 'The amount entered is more than the port balance',
        incorrectPriceOrId: 'The amount or reference id was not entered correctly',
        incorrect_reference_id: 'reference id is not correct',

        receive: {
          success: 'Receipt notified successfully',
          error: 'Receipt notified failed'
        }
      }
    }
  },

  cashBoxes: {
    title: 'Cashes',

    labels: {
      name: 'Name',
      delete: 'Delete'
    },

    confirmations: {
      delete: {
        title: 'Confirm Delete Cash',
        body: 'Are you sure you want to temporarily delete {cashBox} cash?'
      },
      forceDelete: {
        title: 'Confirm Delete Cash',
        body: 'Are you sure you want to delete {cashBox} cash permanently?'
      }
    },

    notifications: {
      insert: {
        success: 'New cash info successfully created',
        error: 'Registering new cash information failed'
      },

      edit: {
        success: 'Cash info successfully updated',
        error: 'Updating new cash information failed'
      },

      delete: {
        success: 'Cash info successfully deleted',
        error: 'Deleting new cash information failed'
      },

      restore: {
        success: 'Cash info successfully restored',
        error: 'Restoring new cash information failed'
      }
    },

    table: {
      header: {
        select: 'Select',
        row: 'Row',
        name: 'Name',
        balance: 'Balance',
        delete: 'Delete',
        restore: 'Restore'
      }
    },

    list: {
      title: 'Cashes'
    },

    trash: {
      title: 'Trashed Cashes'
    },

    insert: {
      title: 'Create Cash'
    },

    edit: {
      title: 'Edit Cash',
      dynamicTitle: 'Edit Box {cashBox}'
    },

    cashBox: {
      title: 'Cash',
      dynamicTitle: '{cashBox} Cash',

      importantData: {
        balance: 'Balance',
        openingBalance: 'Opening balance',
        transactionsCount: 'Number of Transactions'
      },

      actions: {
        transactions: 'Cash Turnover',
        logs: 'Activity logs'
      }
    },

    transactions: {
      title: 'Cash Turnover',
      dynamicTitle: '{cashBox} Cash Turnover',

      table: {
        header: {
          balance: 'Balance',
          price: 'Amount',
          description: 'Documents',
          date: 'Date',
          docNumber: 'Document Number'
        }
      }
    },

    logs: {
      title: 'Cash logs',
    },

    openingBalance: {

      labels: {
        price: 'Amount',
        delete: 'Delete Opening Balance'
      },

      confirmations: {
        delete: {
          title: 'Delete Confirmation',
          body: 'Are you sure you want to delete the cash opening balance?'
        }
      },

      notifications: {
        locked: 'opening balance is the lock',
        negativeBalance: 'Cash cant get negative balance',

        isExisted: {
          message: 'This value is in the list',
          dynamicMessage: 'Box {cashBox} is in the list'
        },

        insert: {
          success: 'The opening balance of the fund in question was successfully registered',
          error: 'The registration of the desired fund opening balance was accompanied by an error'
        },

        edit: {
          success: 'The opening balance of the fund was successfully updated',
          error: 'The first update of the box in question was accompanied by an error'
        },

        delete: {
          success: 'The first fund in question was successfully deleted',
          error: 'The first deletion of the box in question was accompanied by an error'
        }
      },

      table: {
        header: {
          delete: 'Delete',
          price: 'Amount',
          name: 'Fund Name',
          row: 'Row'
        }
      },

      insert: {
        title: 'Add the first fund course'
      },

      edit: {
        title: 'The first edition of the fund period {cashBox}'
      }
    }
  },

  cost: {
    title: 'Costs',

    paymentTypes: {
      cash: 'Receive cash',
      bank: 'Bank transfer',
      paymentGateway: 'Payment gateway or POS'
    },

    bankTypes: {
      pos: 'POS',
      card: 'card to card',
      sheba: 'sheba'
    },

    types: {
      cash: 'Fund',
      bank: 'Bank',
      user: 'Operator cost',
      storeroom: 'Store',
      paymentGateway: 'Payment gateway',
      custom: 'Account cost'
    },

    labels: {
      all: 'All',
      type: 'Type',
      account: 'Cost headings',
      cash: 'payment from the fund',
      bank: 'Payment from the bank',
      payer: 'payer',
      paymentType: 'payment type',
      price: 'Amount',
      description: 'Description',
      date: 'Date of deposit',
      paymentFrom: 'Payment from',
      paymentTo: 'Payment to',
      maxPayment: 'Maximum payable',
      bankBalance: 'Bank balance',
      cashBoxBalance: 'Funds',
      userBalance: 'Operator balance'
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        price: 'Amount',
        account: 'Cost headings',
        payer: 'Account side',
        creator: 'Creator',
        date: 'Date',
        docNumber: 'Document number'
      }
    },

    notifications: {
      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The deposit date is not entered correctly!',
      type: 'The payment type is not specified',
      price: 'The entered amount is more than the maximum amount that can be paid!',
      future: 'It is not possible to register a fee for the future',
      user: 'Payer not selected'
    },

    insert: {
      title: 'Create Cost',

      notifications: {
        invalidAccount: 'Expenditure heading not selected',
        invalidCash: 'Inbox not selected',
        invalidBank: 'Bank not selected',
        invalidPrice: 'Amount is not valid',
        invalidPaymentType: 'Payment type not specified',
        invalidDescription: 'Expense description not entered',
        lowBalance: 'The balance of the bank or fund is not enough!',
        lowBalanceDynamicDate: 'The balance of the bank or fund in selected date is not enough!',
        incorrect_reference_id: 'reference id is not correct',

        insert: {
          success: 'Expense document created successfully',
          error: 'Creating a cost document was associated with an error'
        }
      },

      suggests: {
        description: 'Received from {user} for {subject}'
      }
    },

    list: {
      title: 'Cost list'
    },

    trash: {
      title: 'Removed Cost List'
    },

    document: {
      title: 'Cost document',
      dynamicTitle: 'Expense document number {docNumber}',

      confirmations: {
        delete: {
          title: 'Confirm Delete Document',
          body: 'Are you sure you want to delete this document completely?'
        }
      },

      notifications: {
        delete: {
          success: 'Expense document information successfully deleted',
          error: 'Deleting the cost document information was accompanied by an error'
        },
        restore: {
          success: 'Expense document information successfully restored',
          error: 'Restore the cost document information was accompanied by an error'
        }
      },

      labels: {
        payer: 'Payer / payers',
        account: 'Cost headings',
        details: 'Other information',
        creator: 'creator',
        date: 'Registration date',
        description: 'Description'
      }
    },

    logs: {
      title: 'Cost logs',
    },
  },

  payment: {
    title: 'Payments',

    bankTypes: {
      pos: 'POS',
      card: 'card to card',
      sheba: 'sheba'
    },

    types: {
      cash: 'fund',
      bank: 'bank',
      user: 'Operator',
      app: 'App',
      storeroom: 'store',
      paymentGateway: 'payment gateway'
    },

    paymentTypes: {
      customer: 'Payment to the customer',
      supplier: 'Payment to the supplier'
    },

    labels: {
      all: 'All',
      type: 'Type',
      paymentType: 'Payment type',
      payeeType: 'Payee type',
      date: 'Date of payment',
      user: 'Pay to',
      source: 'Payment from',
      price: 'Amount',
      description: 'Description',
      transactionsReferenceId: 'Tracking number',
      maxPayment: 'Maximum payable',
      dynamicBalance: 'Credit {balance}',
      bankBalance: 'Bank balance',
      cashBoxBalance: 'Funds'
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        price: 'Amount',
        destination: 'Recipient',
        source: 'Payer',
        description: 'Documents',
        creator: 'Creator',
        date: 'Date',
        docNumber: 'Document number'
      }
    },

    notifications: {
      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The payment date is not entered correctly!',
      future: 'It is not possible to register a payment for the future'
    },

    insert: {
      title: 'Create Payment',

      notifications: {
        invalidUser: 'Person not selected',
        invalidPrice: 'Amount is not valid',
        invalidPaymentFrom: 'Payment source not selected',
        invalidPaymentType: 'Payment type not specified',
        invalidDescription: 'Payment Description has not been entered',
        price: 'The entered amount is more than the maximum amount that can be paid!',
        lowBalance: 'The balance of the bank or fund is not enough!',
        lowBalanceDynamicDate: 'The balance of the bank or fund in selected date is not enough!',
        incorrect_reference_id: 'reference id is not correct',

        insert: {
          success: 'Payment document created successfully',
          error: 'Creating a payment document with an error'
        }
      },

      suggests: {
        description: 'Received from {user} for {subject}'
      }
    },

    list: {
      title: 'Payments'
    },

    trash: {
      title: 'Removed Payments List'
    },

    document: {
      title: 'Payment document',
      dynamicTitle: 'Payment document number {docNumber}',

      confirmations: {
        delete: {
          title: 'Confirm Delete Document',
          body: 'Are you sure you want to delete this document completely?'
        }
      },

      notifications: {
        delete: {
          success: 'Payment document information successfully deleted',
          error: 'Deleting payment document information failed'
        },
        restore: {
          success: 'Payment document information successfully restored',
          error: 'Restore the payment document information was accompanied by an error'
        }
      },

      labels: {
        sources: 'Payer / payers',
        destinations: 'Recipient / recipients',
        details: 'Other information',
        creator: 'creator',
        date: 'Registration date',
        description: 'Description'
      }
    },

    logs: {
      title: 'Payment logs',
    },
  },

  receive: {
    title: 'Receives',

    statusTypes: {
      all: 'All',
      confirm: 'Confirmed',
      cancel: 'Canceled'
    },

    receiveTypes: {
      cash: 'Cash',
      bank: 'Bank transfer',
      paymentGateway: 'Gateway or POS'
    },

    types: {
      cash: 'fund',
      bank: 'bank',
      user: 'Operator',
      app: 'App',
      storeroom: 'Store',
      paymentGateway: 'payment gateway'
    },

    status: {
      confirm: 'Confirm',
      reject: 'Refund',
      draft: 'Draft'
    },

    labels: {
      all: 'All',
      receiveType: 'Receipt type',
      receiverType: 'Receiver type',
      subscriptionCredit: 'Current subscription credit',
      wallet: 'Wallet',
      credit: 'Credit',
      user: 'Receive from',
      cash: 'deposit to fund',
      bank: 'Deposit to bank',
      paymentGateway: 'Deposit to gateway',
      price: 'Amount',
      date: 'Date of deposit',
      description: 'Description',
      transactionsReferenceId: 'Tracking number',
      balance: 'Wallet balance',
      remainingPrice: 'Remaining price',
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        status: 'Status',
        price: 'Amount',
        destination: 'Payee',
        source: 'Payer',
        description: 'Documents',
        creator: 'Creator',
        date: 'Date',
        referenceId: 'Reference id',
        docNumber: 'Document number'
      }
    },

    notifications: {
      cantReturn: 'This receive document cant be refund',

      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      },

      return: {
        success: 'Receipt refund document create successfully',
        error: 'Create receive refund document has error'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The receive date is not entered correctly!',
      future: 'It is not possible to register a receive for the future'
    },

    insert: {
      title: 'Create Receive',
      dynamicTitle: 'Receive from {name}',

      notifications: {
        invalidType: 'Receipt type not selected',
        invalidUser: 'Person not selected',
        invalidPrice: 'Amount not entered',
        lessPrice: 'The amount entered should not be less than {price} {currency}',
        morePrice: 'The amount entered should not be more than {price} {currency}',
        invalidDescription: 'Receipt description not entered',
        invalidTransactionsReferenceId: 'Incorrect tracking number entered',
        invalidCash: 'Inbox not selected',
        invalidBank: 'Bank not selected',
        invalidPaymentGateway: 'Port not selected',
        incorrect_reference_id: 'reference id is not correct',

        insert: {
          success: 'Receipt document created successfully',
          error: 'Creating a receive document with an error'
        },

        parseError: {
          name: 'The selected name is not valid!',
          price: 'The selected amount is not valid!',
          referenceId: 'The tracking number entered has already been used!',
          paymentGateway: 'The selected payment gateway is not valid!'
        }
      },

      suggests: {
        description: 'Received from {user} for {subject}'
      },

      table: {
        header: {
          row: 'Row',
          name: 'Name',
          price: 'Price'
        }
      }
    },

    list: {
      title: 'Receives'
    },

    trash: {
      title: 'Removed Receives List'
    },

    document: {
      title: 'Receipt Document',
      dynamicTitle: 'Receive Document No. {docNumber}',

      confirmations: {
        delete: {
          title: 'Confirm Delete Document',
          body: 'Are you sure you want to delete this document completely?'
        },
        return: {
          title: 'Confirm Refund Document',
          body: 'Are you sure you want to refund this receive document?'
        }
      },

      notifications: {
        delete: {
          success: 'Receipt document information successfully deleted',
          error: 'Deleting the received document information was accompanied by an error'
        },
        restore: {
          success: 'Receipt document information successfully restored',
          error: 'Restore the received document information was accompanied by an error'
        },
        return: {
          success: 'Receipt document successfully refund',
          error: 'Refund the received document information was accompanied by an error'
        }
      },

      labels: {
        sources: 'Payer / payers',
        destinations: 'Recipient / recipients',
        details: 'Other information',
        referenceId: 'Reference id',
        creator: 'creator',
        status: 'Status',
        date: 'Registration date',
        description: 'Description'
      }
    },

    return: {
      title: 'Create Receive Refund',

      labels: {
        user: 'Pay to',
        date: 'Date',
        source: 'Payment from',
        receivePrice: 'Receive amount',
        price: 'Amount',
        description: 'Description',
        descriptionText: 'Receive refund for receive document No. {id}'
      }
    },

    logs: {
      title: 'Receive logs',
    },
  },

  internalFundsTransfer: {
    title: 'Internal Transfer',

    types: {
      cash: 'Cash',
      bank: 'Bank',
      user: '',
      storeroom: 'Store',
      paymentGateway: 'Payment Gateway'
    },

    labels: {
      sourceType: 'Receive from',
      source: '{type} source',
      destinationType: 'deposit to',
      destination: '{type} Destination',
      price: 'Amount',
      date: 'Transfer date',
      bankBalance: 'Bank balance',
      cashBoxBalance: 'Funds',
      hasWage: 'Commission',
      wage: 'Commission deduction',
      referenceId: 'Tracking number',
      description: 'Description'
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        price: 'Amount',
        description: 'Documents',
        payee: 'Payee',
        payer: 'Payer',
        creator: 'Creator',
        date: 'Date',
        referenceId: 'Reference id',
        docNumber: 'Document number'
      }
    },

    notifications: {
      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The transfer date is not entered correctly!',
      future: 'It is not possible to register a transfer for the future'
    },

    insert: {
      title: 'Create Treasury Transfer',

      notifications: {
        invalidPrice: 'Amount is not valid',
        invalidSourceType: 'Source type not selected',
        invalidSource: 'Source not selected',
        invalidDestinationType: 'Destination type not selected',
        invalidDestination: 'Destination not selected',
        equalSourceAndDestination: 'source and destination cannot be the same',
        lowBalance: 'The balance of the bank or fund is not enough',
        lowBalanceDynamicDate: 'The balance of the bank or fund in selected date is not enough!',
        incorrect_reference_id: 'reference id is not correct',

        insert: {
          success: 'Internal transfer document successfully created',
          error: 'The creation of an internal transfer document was accompanied by an error'
        }
      }
    },

    list: {
      title: 'Internal Transfer'
    },

    trash: {
      title: 'Removed Internal Transfer List'
    },

    document: {
      title: 'Internal Transfer Document',
      dynamicTitle: 'Internal Transfer Document No. {docNumber}',

      confirmations: {
        delete: {
          title: 'Confirm Delete Document',
          body: 'Are you sure you want to delete this document completely?'
        }
      },

      notifications: {
        delete: {
          success: 'Treasury transfer document information successfully deleted',
          error: 'Deleting Treasury Transfer Document Information Caused an Error'
        },
        restore: {
          success: 'Treasury transfer document information successfully restored',
          error: 'Restore the treasury transfer document information was accompanied by an error'
        }
      },

      labels: {
        payer: 'Payer / payers',
        destinations: 'Recipient / recipients',
        details: 'Other information',
        referenceId: 'Reference id',
        creator: 'creator',
        date: 'Registration date',
        description: 'Description'
      }
    },

    logs: {
      title: 'Internal Transfer Logs',
    },
  },

  transactions: {
    title: 'Financial Transactions',

    list: {
      title: 'Financial Transactions'
    },

    insert: {
      title: 'Create transaction'
    },

    transaction: {
      title: 'Transaction'
    }
  }
}
